import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { Projects } from './pages/Projects';
import { About } from './pages/About';
import { Trips } from './pages/Trips';
import { GetInvolved } from './pages/GetInvolved';
import { NewsMedia } from './pages/NewsMedia';
import { Donate } from './pages/Donate';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col" data-id="element-2">
        <Navigation data-id="element-3" />
        <main className="flex-1" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/projects" element={<Projects data-id="element-9" />} data-id="element-8" />
            <Route path="/about" element={<About data-id="element-11" />} data-id="element-10" />
            <Route path="/trips" element={<Trips data-id="element-13" />} data-id="element-12" />
            <Route path="/get-involved" element={<GetInvolved data-id="element-15" />} data-id="element-14" />
            <Route path="/news" element={<NewsMedia data-id="element-17" />} data-id="element-16" />
            <Route path="/donate" element={<Donate data-id="element-19" />} data-id="element-18" />
          </Routes>
        </main>
        <Footer data-id="element-20" />
      </div>
    </BrowserRouter>;
}